import { render, staticRenderFns } from "./AdminBilling.vue?vue&type=template&id=7b0b70d2&scoped=true&"
import script from "./AdminBilling.vue?vue&type=script&lang=ts&"
export * from "./AdminBilling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0b70d2",
  null
  
)

export default component.exports